import React, { useState } from 'react';
import './packages.css';
import { FaChevronDown, FaChevronUp, FaBus, FaBinoculars, FaHotel, FaMapMarkedAlt } from 'react-icons/fa';
import { MdOutlineNaturePeople } from 'react-icons/md';
import { useTranslation } from "react-i18next";

import Slider from 'react-slick';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import { Link } from 'react-router-dom';
import useScrollToTop from './ScrollToTop';

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  fade: true,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true
      }
    }
  ]
};

const getIcon = (name) => {
  switch (name) {
    case "bus": return <FaBus />;
    case "binoculars": return <FaBinoculars />;
    case "nature": return <MdOutlineNaturePeople />;
    case "hotel": return <FaHotel />;
    default: return null;
  }
};

const getImage = (name) => {
  switch (name) {
    case "welcome": return "/images/welcome.jpg";
    case "zebracrossing": return "/images/ZEBRA-CROSSING.jpg";
    case "lions": return "/images/WONDER.JPG";
    case "giraffe": return "/images/bonfire.jpg";
    case "chilling": return "/images/seasunset.jpeg";
    case "departure": return "/images/brett-jordan-vjSY59Td6y4-unsplash.jpg";
    case "shela": return "/images/Swahili architecture Lamu, Kenya.jpeg";
    case "nairobi": return "/images/seasunset.jpg";
    case "depart": return "/images/girafe.jpeg";

    default: return null;
  }
};

const DayAccordion = ({ item, isOpen, onClick }) => (
  <div className={`day-accordion${isOpen ? ' open' : ''}`}>
    <div className="day-header" onClick={onClick}>
      <h3>{item.icon} {item.day}</h3>
      <span className="toggle-icon">
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </span>
    </div>

    {isOpen && (
      <div className="day-content-row">
        {/* LEFT CONTENT */}
        <div className="day-text-content">
          <p className="highlight">{item.highlight}</p>
          <div className="details">
            {item.details.map((d, i) => <p key={i}>{d}</p>)}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        {item.image && (
          <div className="day-image-container">
            <img src={item.image} alt={item.day} className="day-image" />
          </div>
        )}
      </div>
    )}
  </div>
);

const Packagenakuru = () => {
  const [openDay, setOpenDay] = useState(null);
  const toggle = idx => setOpenDay(openDay === idx ? null : idx);
  const [activeTab, setActiveTab] = useState("inclusions");
  const { t } = useTranslation("packagenakuru");
  useScrollToTop();

  return (
    <div className="package">
      {/* HERO SECTION */}
      <section className="package-hero">
        <img src="/images/shelaExp.jpeg" alt="Osiligi Reserve" className="hero-image" />
        <div className="phero-overlay" />
        <div className="phero-text">
          <h1>{t("hero.title")}</h1>
          <p>{t("hero.subtitle")}</p>
        </div>
      </section>

      {/* INTRO SECTION */}
      <section className="package-intro">
        <div className="package-intro-content">
          <h2>{t("intro.heading")}</h2>
          <p>{t("intro.paragraph1")}</p>
          <p>{t("intro.paragraph2")}</p>
          <p>{t("intro.paragraph3")}</p>
        </div>
      </section>

      {/* Carousel */}
      <section className="package-carousel-wrapper">
        {/* First carousel */}
        <div className="carousel-container">
          <div className="carousel-wrapper">
            <Slider {...sliderSettings}>
              <div><img src="/images/Swahili architecture Lamu, Kenya.jpeg" alt="Mara Gallery 1" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/seasunset.jpeg" alt="Mara Gallery 2" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/wildbeasts.jpg" alt="Nakuru Gallery 1" className="carousel-image" loading="lazy" /></div>
            </Slider>
          </div>
        </div>

        {/* Second carousel - hidden on mobile */}
        <div className="carousel-container hide-on-mobile">
          <div className="carousel-wrapper">
            <Slider {...sliderSettings}>
              <div><img src="/images/vilashela.jpg" alt="Nakuru Gallery 2" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/cliff-kenya-banner7.jpg" alt="Naivasha Gallery 1" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/seasunset.jpeg" alt="Naivasha Gallery 2" className="carousel-image" loading="lazy" /></div>
            </Slider>
          </div>
        </div>
      </section>

      {/* Activities Highlights */}
      <section className="activities-section">
        <div className="activities container">
          <h2 className="activities-title">{t("activitiesTitle")}</h2>

          <div className="activities-card">
            <ul className="activities-list">
              {t("activities", { returnObjects: true }).map((activity, index) => (
                <li key={index}>
                  <strong>{activity.title}</strong> — {activity.description}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Itinerary outline */}
      <section className="package-itinerary">
        <h2><FaMapMarkedAlt /> {t("itineraryTitle")}</h2>
        <div className="accordion-wrapper">
          {t("itinerary", { returnObjects: true }).map((item, i) => (
            <DayAccordion
              key={i}
              item={{
                ...item,
                icon: getIcon(item.icon),
                image: getImage(item.image)
              }}
              isOpen={openDay === i}
              onClick={() => toggle(i)}
            />
          ))}
        </div>
      </section>

      {/* Accommodation tables */}
      <div className='accomodation-card'>
        {/* On budget Card */}
        <h5>{t("accommodationSection.budget.title")}</h5>
        <div className='onBudget-card'>
          <div className='charge-section'>
            <table>
              <thead>
                <tr>
                  {t("accommodationSection.headers", { returnObjects: true }).map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {t("accommodationSection.budget.rates", { returnObjects: true }).map((row, index) => (
                  <tr key={index}>
                    <td data-label="Months & Dates">{row.dates}</td>
                    <td data-label="1 Person">{row.person1}</td>
                    <td data-label="2-3 People">{row.people2to3}</td>
                    <td data-label="4-6 People">{row.people4to6}</td>
                    <td data-label="7 + People">{row.people7plus}</td>
                    <td data-label="Young Adult">{row.youngAdult}</td>
                    <td data-label="Child U12">{row.child}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='accomodationImg-card'>
            <img src="/images/oldarpoi_room1.jpg" alt="Budget Camp" />
          </div>
        </div>

        {/* Luxury Tented Camp */}
        <h5>{t("accommodationSection.luxury.title")}</h5>
        <div className='luxury-card'>
          <div className='accomodationImg-card'>
            <img src="/images/panorama.jpg" alt="Luxury Camp" />
          </div>
          <div className='charge-section'>
            <table>
              <thead>
                <tr>
                  {t("accommodationSection.headers", { returnObjects: true }).map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {t("accommodationSection.luxury.rates", { returnObjects: true }).map((row, index) => (
                  <tr key={index}>
                    <td data-label="Months & Dates">{row.dates}</td>
                    <td data-label="1 Person">{row.person1}</td>
                    <td data-label="2-3 People">{row.people2to3}</td>
                    <td data-label="4-6 People">{row.people4to6}</td>
                    <td data-label="7 + People">{row.people7plus}</td>
                    <td data-label="Young Adult">{row.youngAdult}</td>
                    <td data-label="Child U12">{row.child}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <p className='volnote'>
          <b>{t("accommodationSection.note.label")}</b> {t("accommodationSection.note.text")}
        </p>
      </div>

      {/* INCLUSIONS AND EXCLUSIONS */}
      <section className="package-details-wrapper">
        <div className="left-section">
          <div className="card-container">
            <div className="tab-buttons">
              <button
                className={activeTab === "inclusions" ? "active" : ""}
                onClick={() => setActiveTab("inclusions")}
              >
                {t("packageDetails.tabs.inclusions")}
              </button>
              <button
                className={activeTab === "exclusions" ? "active" : ""}
                onClick={() => setActiveTab("exclusions")}
              >
                {t("packageDetails.tabs.exclusions")}
              </button>
            </div>

            {activeTab === "inclusions" ? (
              <div className="inclusions-card">
                <h3>{t("packageDetails.tabs.inclusions")}</h3>
                <ul className="inclusions-list">
                  {t("packageDetails.inclusions", { returnObjects: true }).map(
                    (item, index) => (
                      <li key={index}>{item}</li>
                    )
                  )}
                </ul>
              </div>
            ) : (
              <div className="exclusions-card">
                <h3>{t("packageDetails.tabs.exclusions")}</h3>
                <ul className="exclusions-list">
                  {t("packageDetails.exclusions", { returnObjects: true }).map(
                    (item, index) => (
                      <li key={index}>{item}</li>
                    )
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="planner-info">
          <img src="/images/setek.jpeg" alt="Planner" />
          <h4>{t("packageDetails.planner.name")}</h4>
          <p>Safari Planner</p>
          <p>
            Phone:{" "}
            <a href={`tel:${t("packageDetails.planner.phone")}`}>
              {t("packageDetails.planner.phone")}
            </a>
          </p>
          <p>
            Email:{" "}
            <a href={`mailto:${t("packageDetails.planner.email")}`}>
              {t("packageDetails.planner.email")}
            </a>
          </p>
        </div>
      </section>

      {/* Call to Action */}
      <section className="place-cta" aria-label="Call to Action Section">
        <h2>{t("cta.title")}</h2>
        <p>{t("cta.text")}</p>
        <Link to="/contact?source=packagenakuru" className="book-now">
          {t("cta.button")}
        </Link>
      </section>
    </div>
  );
};

export default Packagenakuru;